export default __webpack_public_path__ + "static/1565-c6def8b0416ef72e50dcef5a84e4bee1.gif";